<template>
  <div v-if="options?.length">
    <template v-if="options[0].type === 'select' && !colorsArray?.length">
      <select-field
          v-model="model"
          :options="productOptions"
          :placeholder="placeholder"
          option-name="name"
          return-object
      ></select-field>
    </template>

    <template v-else>
      <template v-if="optionsArray?.length">
        <div class="mb-2">{{ optionLabel }}: {{ modelValue?.name }}</div>
        <div class="flex overflow-x-auto flex-wrap cursor-pointer">
          <nuxt-link
              v-for="option in optionsArray"
              :key="`sub-option-${option.product_option_value_id}`"
              :class="{
              'border-secondary bg-secondary-light':
                option.product_option_value_id ===
                modelValue?.product_option_value_id,
            }"
              :to="getFormattedProductOptionLink(option.product_option_variant_id)"
              class="border rounded mb-2 p-2 ltr:mr-2 rtl:ml-2"
          >
            <div class="text-[11px] mb-1">{{ option.name }}</div>
            <niceone-price :price="option?.specials?.length ? option.specials[0]?.price_formated : option?.price_formated"/>
          </nuxt-link>
        </div>
      </template>

      <template v-if="colorsArray?.length">
        <div class="mb-2">{{ optionLabel }}: {{ modelValue?.name }}</div>
        <div class="flex gap-1 overflow-x-auto flex-wrap relative cursor-pointer">
          <nuxt-link
              v-for="option in colorsArray"
              :key="`sub-option-${option.product_option_value_id}`"
              :class="{ 'border border-secondary': option.product_option_value_id === modelValue?.product_option_value_id }"
              :to="getFormattedProductOptionLink(option.product_option_variant_id)"
              class="flex-center rounded-full p-[2px]"
          >
            <div :style="{ border: '1px solid #f2f2f2', 'background-color': `#${option.hex_color}` }"
                 class="w-[26px] h-[26px] rounded-full">
              <div v-if="!option?.has_stock" class="flex-center w-full h-full">
                <van-icon name="cross"></van-icon>
              </div>
            </div>
          </nuxt-link>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import SelectField from "@/components/form/SelectField";

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {
    },
  },
  options: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
  },
});

const model = computed({
  get() {
    return props.modelValue;
  },
  set(option) {
    selectOption(option);
  },
});

const emit = defineEmits(["update:modelValue", "change"]);

const selectOption = (option = {}) => {
  emit("update:modelValue", option);
  emit("change");
};

const hasOptions = computed(() => props.options?.length || false);
const optionLabel = computed(() => {
  if (!hasOptions.value) return "";
  return props.options[0].name;
});

const productOptions = computed(() => {
  return !hasOptions.value ? [] : props.options[0].option_value;
});

// For colors options
const colorsArray = computed(() => {
  return productOptions.value.filter((item) => item.hex_color);
});

// For non colors options usually ml or size
const optionsArray = computed(() => {
  return productOptions.value.filter((item) => !item.hex_color);
});

const route = useRoute()
const getFormattedProductOptionLink = (variantId) => {
  const path = route.path.replace(/-\d+\/?$/, '')
  return useNuxtApp().$routerUrl(`${path}-${variantId}`)
}
</script>
